import React from 'react';
import { endOfDay, startOfDay } from 'date-fns';
import { DateRangeCalendar, getActiveQuickRangeId } from 'common/components';
import type { DateRangeType } from '../../../../AgenticWorkflowDetail.types';
import {
    CALL_ANALYTICS_QUICK_RANGE_OPTIONS,
    isNext30DaysRange,
    quickRangeIdToCallAnalyticsDateRangeType,
} from './callAnalyticsDateRange.utils';

import styles from './CallAnalyticsDateRangeSelector.module.scss';

export type CallAnalyticsDateRangeSelectorProps = {
    startDate: Date | null;
    endDate: Date | null;
    onDateRangeTypeChange: (range: string) => void;
    onDateRangeChange: (dateRange: [Date | null, Date | null]) => void;
};

const resolveDateRangeType = (normalizedStart: Date, calendarEnd: Date): DateRangeType => {
    if (isNext30DaysRange(normalizedStart, calendarEnd)) {
        return 'next30Days';
    }

    const quickRangeId = getActiveQuickRangeId(
        normalizedStart,
        calendarEnd,
        new Date(),
        null,
        CALL_ANALYTICS_QUICK_RANGE_OPTIONS
    );

    return quickRangeIdToCallAnalyticsDateRangeType(quickRangeId);
};

export const CallAnalyticsDateRangeSelector: React.FC<CallAnalyticsDateRangeSelectorProps> = ({
    startDate,
    endDate,
    onDateRangeTypeChange,
    onDateRangeChange,
}) => (
    <DateRangeCalendar
        startDate={startDate}
        endDate={endDate}
        monthsShown={1}
        position='left'
        aria-label='Date range'
        quickRangeOptions={CALL_ANALYTICS_QUICK_RANGE_OPTIONS}
        triggerClassName={styles.trigger}
        className={styles.dateRangeCalendar}
        onApply={({ startDate: appliedStart, endDate: appliedEnd }) => {
            const normalizedStart = startOfDay(appliedStart);
            const normalizedEnd = endOfDay(appliedEnd);
            const calendarEnd = startOfDay(appliedEnd);
            const dateRangeType = resolveDateRangeType(normalizedStart, calendarEnd);

            onDateRangeTypeChange(dateRangeType);
            onDateRangeChange([normalizedStart, normalizedEnd]);
        }}
    />
);
